import Component from "./Permissions";

export default Component;
